import React from "react"

import pdf from './Manual_Portal_Atualizado.pdf'

import './styles.css'

export default function Ajuda() {

    return (
        <>
            <embed data-testid='vendas-pdf' className='vendas-pdf' type='application/pdf' src={pdf}/>
        </>
    )
} 